import { HStack, Link, Text } from "@chakra-ui/react";
import useTranslate from "@raiden/library/hooks/useTranslate";
import { Icon } from "../../../../../../components/Icon";
import { getMenuItemAdapterValues } from "../../../../../../helpers/menus/getMenuItemAdapterValues";

/**
 * @typedef {Object} Props
 * @property {import("@raiden/library/types/Configuration").ConfigurationMenuItem} menuItem
 */
/**
 * @param {Props} props
 */
export function MenuItem({ menuItem }) {
  const translate = useTranslate();

  const { title, href, target, icon } = getMenuItemAdapterValues({
    menuItem,
    translate,
  });

  return (
    <Link
      href={href}
      target={target}
      fontSize="0.875rem"
      fontWeight={400}
      lineHeight="1.3125rem">
      <HStack>
        {icon !== null && (
          <Icon icon={icon} size="1.5rem" color="brandPrimary.700" />
        )}

        <Text as="span">{title}</Text>
      </HStack>
    </Link>
  );
}
